export const headerBundle = {
  selectDong: {
    ko: "동 선택",
    en: "Select Building",
    es: "Seleccionar edificio"
  },

  caption: {
    ko: "누수 세대 분석",
    en: "Water Leak Analysis",
    es: "Análisis de fugas de agua"
  },
  search: {
    ko: "검색",
    en: "Search",
    es: "Buscar"
  }
}
